import _ from "lodash";
import { useEffect, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectListItems } from "../../../../../../redux/library/selector";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { opennetworkCategories } from "../../../../../../redux/opennetwork-categories/action";
import { selectOpennetworkCategoriesListItems } from "../../../../../../redux/opennetwork-categories/selector";
import { tenantOpenNetworkDomains } from "../../../../../../redux/tenant-open-network-domains/action";
import { selectTenantOpennetworkDomainsListItems } from "../../../../../../redux/tenant-open-network-domains/selector";
import { InputContainer } from "../../../../../../common/components/form/form.module";

export const DBNGlobalCategoriesList = ({
  closeModal,
  handleSubmit,
}: any) => {
  const dispatch = useAppDispatch();
  const domainsListData = useSelector(selectTenantOpennetworkDomainsListItems)  
  const categoriesListData = useSelector(selectOpennetworkCategoriesListItems);
  const libraryData = useSelector(selectListItems);

  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);
  const [selectedDomain, setSelectedDomain] = useState<any>(null);

  const [updatedCategoriesList, setUpdatedCategoriesList] = useState<any>([]);

  // Column Definitions - Memoized
  const columnDefs = useMemo(
    () => [
      {
        field: "Sl",
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: "Sl",
        cellRenderer: (params: any) => parseInt(params.node.id, 10) + 1,
      },
      { field: "Name", headerName: "Name", searchField: "Name", sortable: true, filter: true, filterType: "text" },
      { field: "Code", headerName: "Code", searchField: "Code", sortable: true, filter: true, filterType: "text" },
      {
        field: "IsSubCategory",
        headerName: "Is SubCategory",
        cellRenderer: "yesNoRenderer",
        searchField: "IsSubCategory",
        sortable: true,
        filter: true,
        filterType: "text",
      },
      {
        field: "ParentCategoryName",
        headerName: "Parent Category",
        searchField: "ParentCategoryName",
        sortable: true,
        filter: true,
        filterType: "text",
      },
      {
        field: "GlobalDBNDomainName",
        headerName: "Domain",
        searchField: "GlobalDBNDomainName",
        sortable: true,
        filter: true,
        filterType: "text",
      },
    ],
    []
  );



  // API Call - Memoized
  const listDBNDomains = useCallback(() => {
    dispatch(tenantOpenNetworkDomains.resetAction({ actionType: 'list' }))
    dispatch(tenantOpenNetworkDomains.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch`,
      entity: 'tenantOpenNetworkDomains',
      jsonData: {
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }, [dispatch]);

  const listDBNGlobalCategories = useCallback(() => {
    dispatch(opennetworkCategories.resetAction({ actionType: "list" }));
    dispatch(
      opennetworkCategories.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
        entity: "tenantOpenNetworkDomains",
        jsonData: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "Id",
          SortOrder: "desc",
          Searches: searchCriteriaList,
        },
      })
    );
  }, [dispatch, pageData, pageSize, searchCriteriaList]);

  useEffect(() => {
    listDBNGlobalCategories();
  }, [listDBNGlobalCategories]);

  useEffect(() => {
    listDBNDomains();
  }, [listDBNDomains]);

  // Search handler - Memoized
  const handleSearch = useCallback((data: any) => {
    let searchCriteria = []
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    setSearchCriteriaList(searchCriteria)
    listDBNGlobalCategories();    
  }, []);

  
  const additionButtons: any = [ 
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },   
];

  // Reload handler - Memoized
  const handleReloadData = useCallback(() => {
    // console.log("Reloading data...");
    listDBNGlobalCategories();
  }, []);

  // Select handler - Functional Update
  const handleSelect = useCallback((data: any) => {
    setUpdatedCategoriesList((prev) => [...prev, ...data]);
  }, []);

  // Submit handler - Memoized
  const handleSelectCategories = useCallback(() => {
    handleSubmit(updatedCategoriesList);
  }, [handleSubmit, updatedCategoriesList]);

  useEffect(() => {
    console.log('categoriesListData', categoriesListData)
  }, [categoriesListData]);
  

  return (
    <>
      <div className="flex flex-row p-4 justify-start items-end">
        <InputContainer
          label="Domain"
          labelField="Name"
          list={domainsListData?.result?.items}
          onValueChange={(event: any, newValue: any) => {
            setSelectedDomain(event.target.value)
          }}
          optionName="Choose Domain"
          type="select"
          value={selectedDomain}
          valueField="Name"
        />
        <button onClick={()=>handleSearch({
              "column": "GlobalDBNDomainName",
              "value": selectedDomain
          })} 
          disabled={!selectedDomain}
          type="button" className={`ml-4 h-10 bg-blue-700 disabled:bg-gray-400 text-white rounded font-medium px-4 py-3}`}>
          Filter
        </button>
      </div>
      <Table
        columnData={columnDefs}
        rowData={categoriesListData?.result?.items}
        setPageData={setPageData}
        setPageSize={setPageSize}
        enableFilter={true}
        onSearch={handleSearch}
        onSelect={handleSelect}
        searchCriteriaList={searchCriteriaList}
        paginationData={categoriesListData?.result?.pagination}
        checkboxConfig={{
          allowMultiSelect: true,
          defaultSelectedIds: [],
          isDisabled: false,
          keyColumn: "GlobalDBNCategoryId",
        }}
        additionButtons={additionButtons}
        headingName="DBN Global Categories"
      />
      <div className="flex w-full justify-end items-end">
        <button onClick={closeModal} type="button" className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3">
          Close
        </button>
        <button
          disabled={updatedCategoriesList?.length === 0}
          className={`m-2 ${updatedCategoriesList?.length === 0 ? "bg-gray-400" : "bg-blue-700"} text-white rounded font-medium px-4 py-3`}
          onClick={handleSelectCategories}
          type="submit"
        >
          Import Selected Categories
        </button>
      </div>
    </>
  );
};

export default DBNGlobalCategoriesList;
